import ITHeaderText, { ITHeaderTextWrap } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { CustomRenderString } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import '../buyHeader.sass'

interface BuyRealOnlyHeaderAccountsProps extends InputTableLeftTabsProps {}

const BuyRealOnlyHeaderAccounts: React.FC<BuyRealOnlyHeaderAccountsProps> = ({ headerData, handleChange}) => {
    const accounts = headerData.OrderAccounts
    const { t } = useTwinTranslation()
    const accountsSections: FormRender<any> = []
    if (accounts?.length) {
        for (let key in accounts) {
            const account = accounts[key]
            if (account.name !== '--other') {
                accountsSections.push({
                    cols: 1,
                    className:  `buyOrderAccount buyOrderAccountReadOnly ' + ${parseInt(key) === (accounts.length - 1) ? 'isLast' : ''}`,
                    elements: [
                        {
                            name: 'account_' + key,
                            component: 'Custom',
                            render: ({ value }) => <ITHeaderText label={t('chapter', 'Capítulo')} value={account.name} />
                        },
                        {
                            name: 'account_' + key,
                            component: 'Custom',
                            render: ({ value }) => account.description ? <ITHeaderTextWrap label={t('description', 'Descripción')} value={account.description} /> : <div></div>,
                        },
                    ]
                })
            }
        }
    }else {
            accountsSections.push({
                title: '',
                cols: 1,
                elements: [
                    {
                        name: 'noAccounts',
                        component: 'Custom',
                        render: () => <CustomRenderString value={t('noBuyOrderAccounts', 'Sin capítulos')} />
                    },
                ]
            })
        }
    const sections: FormRender<any> = [
        ...accountsSections,
    ]

    return (
        <InputTableLeftColumnForm form={sections} headerData={headerData} handleChange={handleChange} />
    )
}

export default BuyRealOnlyHeaderAccounts